import { render, staticRenderFns } from "./CurationRequestDetail.vue?vue&type=template&id=cc94fe8a&scoped=true"
import script from "./CurationRequestDetail.vue?vue&type=script&lang=js"
export * from "./CurationRequestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc94fe8a",
  null
  
)

export default component.exports